/**
 * Scroll Position Preserver
 * =========================
 */
(function () {
  'use strict';
  var STORAGE_KEY = 'eiko_scroll_positions';
  var EXPIRY_MS = 30 * 60 * 1000;

  var LIST_PATTERNS = [
    /\/collections\//,
    /\/pages\/curated-looks\b/
  ];
  var DETAIL_LINK_SELECTOR = 'a[href*="/products/"], a[href*="/pages/look-"]';

  function isListPage() {
    var path = window.location.pathname;
    return LIST_PATTERNS.some(function (re) { return re.test(path); });
  }
  function getStoredPositions() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function savePosition() {
    if (!isListPage()) return;
    var positions = getStoredPositions();
    positions[window.location.pathname] = { y: window.scrollY, time: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
  }
  function restorePosition() {
    if (!isListPage()) return;
    var positions = getStoredPositions();
    var saved = positions[window.location.pathname];
    if (!saved) return;
    if (Date.now() - saved.time > EXPIRY_MS) {
      delete positions[window.location.pathname];
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
      return;
    }
    requestAnimationFrame(function () {
      setTimeout(function () {
        window.scrollTo(0, saved.y);
        delete positions[window.location.pathname];
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
      }, 100);
    });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest(DETAIL_LINK_SELECTOR);
    if (link && isListPage()) savePosition();
  });
  window.addEventListener('beforeunload', function () {
    if (isListPage()) savePosition();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restorePosition);
  } else {
    restorePosition();
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) restorePosition();
  });
})();
